module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo.2538930e.png" + "?" + Date.now();